import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import { ENotifyMethods } from "../../../models"
import AddNotifyMethodDialog from "./AddNotifyMethodDialog"
import strings from "../../../localization/strings"
import { EnumValues } from 'enum-values';
interface IProps {
  readonly?: boolean
  notifyMethods: ENotifyMethods[]
  error: string
  handleChange(notifyMethods: ENotifyMethods[]): void
}
interface IState {
  openAddNotifyMethodDialog: boolean
}

export default class EmpPermissionChip extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      openAddNotifyMethodDialog: false,
    }
    autobind(this)
  }

  handleDelete(notifyMethod: ENotifyMethods) {
    let notifyMethods = this.props.notifyMethods.slice().filter(item => item !== notifyMethod)
    if (notifyMethods.length === 1 && notifyMethods.includes(ENotifyMethods.App)) {
      notifyMethods = []
    }
    this.props.handleChange(notifyMethods)
  }

  handleAdd(notifyMethod) {
    this.setState({ openAddNotifyMethodDialog: false })
    let notifyMethods = this.props.notifyMethods.slice()
    notifyMethods.push(notifyMethod)
    notifyMethods = notifyMethods.filter(i => i !== ENotifyMethods.App)
    notifyMethods.push(ENotifyMethods.App)
    this.props.handleChange(notifyMethods)
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}>{strings.Notify_Method}</span>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {this.props.notifyMethods.map((notifyMethod, index) =>
            <Chip
              key={index}
              style={{ marginTop: 10, marginRight: 5, height: 35 }}
              onRequestDelete={(this.props.readonly || notifyMethod === ENotifyMethods.App) ? null : () => this.handleDelete(notifyMethod)}
            >
              {strings[notifyMethod]}
            </Chip>
          )}
          <div style={{ height: 40, marginTop: 2, marginLeft: -5, display: "inline-block" }}>
            {!this.props.readonly && !this.state.openAddNotifyMethodDialog && this.props.notifyMethods.length !== EnumValues.getValues(ENotifyMethods).length &&
              <IconButton onTouchTap={() => this.setState({ openAddNotifyMethodDialog: true })}>
                <FontIcon className="fa fa-plus-circle" />
              </IconButton>
            }
          </div>
        </div>
        {this.props.error && !this.state.openAddNotifyMethodDialog &&
          <div style={{ position: "absolute", fontSize: 12, color: "rgb(244, 67, 54)", transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}>
            {this.props.error}
          </div>
        }
        {this.state.openAddNotifyMethodDialog &&
          <AddNotifyMethodDialog
            existingNotifyMethods={this.props.notifyMethods}
            handleClose={() => this.setState({ openAddNotifyMethodDialog: false })}
            handleSave={notifyMethod => this.handleAdd(notifyMethod)}
          />
        }
      </div>
    )
  }
}